import { render, staticRenderFns } from "./order_summary.vue?vue&type=template&id=afb08fa0&scoped=true&"
import script from "./order_summary.vue?vue&type=script&lang=js&"
export * from "./order_summary.vue?vue&type=script&lang=js&"
import style0 from "./order_summary.vue?vue&type=style&index=0&id=afb08fa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb08fa0",
  null
  
)

export default component.exports